import { useManageTable } from "hooks";
import { useMemo } from "react";

import { useMarketingContacts } from "../apis";
import { MARKETING_CONTACTS_PAGE_SIZE } from "../constants";
import { GetMarketingContactsParams } from "../marketing.types";

const useMarketingContactsList = () => {
  const { page, setPage, searchValue, setSearchValue, debouncedSearch } =
    useManageTable();

  const params: GetMarketingContactsParams = useMemo(
    () => ({
      page,
      take: MARKETING_CONTACTS_PAGE_SIZE,
      search: debouncedSearch || undefined
    }),
    [page, debouncedSearch]
  );

  const { contacts, total, isLoading } = useMarketingContacts(params);

  return {
    contacts,
    total,
    isLoading,
    page,
    setPage,
    searchValue,
    setSearchValue
  };
};

export default useMarketingContactsList;
